// src/pages/ImprintPage.js
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

function ImprintPage() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-header">
        <button className="page-title-btn" onClick={() => navigate('/')}>
          <img src="/logo.png?v=2" alt="" className="header-logo" />
          PlantID Game
        </button>
      </div>
      <div className="legal-content">
        <h1>Imprint / Impressum</h1>

        <section className="legal-section">
          <h2>English</h2>

          <h3>Legal Notice (Imprint)</h3>

          <h3>Information pursuant to Section 5 TMG</h3>
          <p>
            Vincent Bunge<br />
            Mahonienweg 46N<br />
            12437 Berlin<br />
            plantidentificationgame@gmail.com
          </p>

          <h3>Responsible for content pursuant to Section 18(2) MStV</h3>
          <p>
            Vincent Bunge<br />
            Mahonienweg 46N<br />
            12437 Berlin<br />
          </p>

          <h3>Liability for Content</h3>
          <p>
            The contents of this website have been created with great care.
            However, we cannot guarantee the accuracy, completeness, or timeliness of the content.
          </p>

          <h3>Liability for Links</h3>
          <p>
            This website may contain links to external third-party websites.
            We have no influence on the contents of those websites.
            The respective provider or operator is always responsible for the content of linked pages.
          </p>
        </section>

        <section className="legal-section">
          <h2>Deutsch</h2>

          <h3>Impressum</h3>
          <h3>Angaben gemäß § 5 TMG</h3>
          <p>
            Vincent Bunge<br />
            Mahonienweg 46N<br />
            12437 Berlin<br />
            plantidentificationgame@gmail.com
          </p>

          <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
          <p>
            Vincent Bunge<br />
            Mahonienweg 46N<br />
            12437 Berlin<br />
          </p>

          <h3>Haftung für Inhalte</h3>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
            Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>

          <h3>Haftung für Links</h3>
          <p>
            Diese Website enthält gegebenenfalls Links zu externen Websites Dritter.
            Auf deren Inhalte haben wir keinen Einfluss.
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
        </section>
      </div>
    </div>
  );
}

export default ImprintPage;
